import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowRight, ListChecks, SlidersHorizontal, Zap } from "lucide-react";

const steps = [
  {
    number: "01",
    icon: ListChecks,
    title: "Pick your tickers",
    description:
      "Add the stocks you want to watch. Start with 5 tickers for just $3/mo, and scale up as you need.",
  },
  {
    number: "02",
    icon: SlidersHorizontal,
    title: "Set your thresholds",
    description:
      'Define what "unusual volume" means to you. 200% spike? 500%? You decide.',
  },
  {
    number: "03",
    icon: Zap,
    title: "Get alerted instantly",
    description:
      "We monitor 24/7. When your criteria hits, you get an SMS or email in seconds.",
  },
];

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-20 md:py-28 px-6 bg-muted/40">
      <div className="container mx-auto">
        <div className="max-w-2xl mx-auto text-center mb-16">
          <p className="text-sm font-semibold text-accent uppercase tracking-wide mb-3">
            How it works
          </p>
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Set up in under 5 minutes
          </h2>
          <p className="text-lg text-muted-foreground">
            No complex setup. If you can set an alarm, you can use RadarTicker.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8 md:gap-12">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                {/* Connector line */}
                {index < steps.length - 1 && (
                  <div className="hidden md:block absolute top-8 left-full w-full h-px bg-border -translate-x-6" />
                )}

                <div className="text-center md:text-left">
                  <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-accent/10 mb-4">
                    <step.icon className="h-6 w-6 text-accent" />
                  </div>
                  <div className="text-xs font-semibold text-accent mb-2 uppercase tracking-wider">
                    Step {step.number}
                  </div>
                  <h3 className="text-xl font-semibold mb-2">{step.title}</h3>
                  <p className="text-muted-foreground leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <Button
              variant="cta"
              size="lg"
              className="text-base font-semibold group"
              asChild
            >
              <Link to="/signup">
                Get started now
                <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-0.5 transition-transform" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
